import { Card, CardContent } from "../../../card";
interface Step {
  title: string;
  description?: string;
  icon?: string; // Could be lucide icon name or emoji
}

interface ProcessFlowProps {
  data: {
    title?: string;
    steps: Step[];
  };
}

export const ProcessFlow = ({ data }: ProcessFlowProps) => {
  if (!data?.steps || !Array.isArray(data.steps)) return null;

  return (
    <Card className="my-8">
      <CardContent className="p-6">
        {data.title && (
          <h3 className="text-lg font-semibold text-neutral-900 mb-8">{data.title}</h3>
        )}

        <div className="relative">
          {/* Desktop Horizontal Layout */}
          <div className="hidden md:flex justify-between items-start gap-4">
            {data.steps.map((step, idx) => (
              <div key={idx} className="flex-1 flex flex-col items-center text-center relative group">
                {/* Connector Line */}
                {idx < data.steps.length - 1 && (
                  <div className="absolute top-5 left-1/2 w-full h-[2px] bg-gradient-to-r from-orange-200 to-orange-100 -z-10 group-hover:from-orange-400 group-hover:to-orange-300 transition-all" />
                )}

                <div className="w-10 h-10 rounded-full bg-white border-2 border-orange-200 flex items-center justify-center font-bold text-orange-500 mb-4 group-hover:border-orange-500 group-hover:bg-gradient-to-br group-hover:from-orange-500 group-hover:to-orange-600 group-hover:text-white group-hover:shadow-[0_4px_12px_rgba(255,107,53,0.25)] transition-all duration-200 z-10 shadow-sm">
                  {idx + 1}
                </div>

                <h4 className="font-semibold text-neutral-900 mb-2 group-hover:text-orange-700 transition-colors">{step.title}</h4>
                {step.description && (
                  <p className="text-sm text-neutral-500 leading-relaxed max-w-[200px]">{step.description}</p>
                )}
              </div>
            ))}
          </div>

          {/* Mobile Vertical Layout */}
          <div className="flex md:hidden flex-col gap-6">
            {data.steps.map((step, idx) => (
              <div key={idx} className="flex gap-4 relative">
                <div className="flex flex-col items-center">
                  <div className="w-8 h-8 rounded-full bg-gradient-to-br from-orange-500 to-orange-600 flex items-center justify-center font-bold text-sm text-white z-10 shadow-[0_2px_8px_rgba(255,107,53,0.2)]">
                    {idx + 1}
                  </div>
                  {idx < data.steps.length - 1 && (
                    <div className="w-[2px] flex-1 bg-gradient-to-b from-orange-400 to-orange-200 my-1" />
                  )}
                </div>

                <div className="pb-6">
                  <h4 className="font-semibold text-neutral-900 mb-1">{step.title}</h4>
                  {step.description && (
                    <p className="text-sm text-neutral-500 leading-relaxed">{step.description}</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
